import { apiRequest } from './http';
import type { StreamResponse } from '../types/stream';

// GET /stream -> playlist items + config (Bearer token required).
export async function fetchStream(): Promise<StreamResponse> {
  return apiRequest<StreamResponse>('stream');
}
